module.exports = __webpack_public_path__ + "static/img/miaosha1.c21db733.png";